export const domain = "https://britannia-pharmacy.com";
